
import React, { useState, useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Products } from './components/Products';
import { Features } from './components/Features';
import { Contact } from './components/Contact';
import { AIChat } from './components/AIChat';
import { CONTENT, PRODUCTS } from './constants';
import { Language } from './types';

const App: React.FC = () => {
  const [lang, setLang] = useState<Language>('en');
  const t = CONTENT[lang];

  // Inject Structured Data for SEO
  useEffect(() => {
    const scriptId = 'structured-data-jsonld';
    let script = document.getElementById(scriptId) as HTMLScriptElement;
    
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "CloudResell Pro",
      "alternateName": "CloudResell.pro",
      "url": "https://iyun.io",
      "logo": "https://iyun.io/logo.png",
      "description": "Leading cloud reseller for verified AWS, Azure, Google Cloud, and Aliyun accounts with no KYC requirements.",
      "knowsAbout": ["Amazon Web Services", "Microsoft Azure", "Google Cloud Platform", "Alibaba Cloud", "Cloud Computing", "Cybersecurity"],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "url": "https://t.me/ksiuiwi552"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Verified Cloud Accounts",
        "itemListElement": PRODUCTS.map((p, idx) => ({
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": p.name + " Verified Account",
            "description": p.description,
            "brand": {
              "@type": "Brand",
              "name": p.name
            }
          },
          "position": idx + 1
        }))
      }
    };

    script.text = JSON.stringify(structuredData);
  }, []);

  return (
    <div className="min-h-screen bg-slate-900 text-slate-50">
      <Navbar lang={lang} setLang={setLang} t={t.nav} />
      <main>
        <Hero t={t.hero} />
        <Products t={t.products} />
        <Features t={t.features} />
        <Contact t={t.contact} />
      </main>
      <AIChat lang={lang} t={t.ai} />
    </div>
  );
};

export default App;
